import React, { FC } from "react";

import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import { Text } from "@bookingcom/bui-react";
import { UIFlightSegment, UIIncludedProductSegment } from "@flights/types";

import { BaggageItem } from "./BaggageItem";
import styles from "./BaggageSegment.module.css";

export const BaggageSegment: FC<{
  flightSegment: UIFlightSegment;
  baggageSegment: UIIncludedProductSegment;
  showHeader?: boolean;
  hideIncludedSection?: boolean;
}> = ({ flightSegment, baggageSegment, showHeader, hideIncludedSection }) => {
  return (
    <div>
      {showHeader && <Header flightSegment={flightSegment} />}
      <BaggageSegmentList hideIncludedSection={hideIncludedSection} baggageSegment={baggageSegment} />
    </div>
  );
};

const Header: FC<{ flightSegment: UIFlightSegment }> = ({ flightSegment }) => {
  const i18n = useI18n();
  const { arrivalAirport } = flightSegment;

  return (
    <Text variant="strong_1" className={styles.header}>
      {i18n.trans(
        t("flights_details_route", {
          variables: {
            city_name: arrivalAirport.cityName || arrivalAirport.name
          }
        })
      )}
    </Text>
  );
};

const BaggageSegmentList: FC<{ baggageSegment: UIIncludedProductSegment; hideIncludedSection?: boolean }> = ({
  baggageSegment,
  hideIncludedSection
}) => {
  return (
    <>
      {baggageSegment.map((item, i) => {
        return (
          <div className={styles.listItem} key={`${item.luggageType}-${i}`}>
            <BaggageItem luggage={item} hideIncludedSection={hideIncludedSection} />
          </div>
        );
      })}
    </>
  );
};
